import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";

import _ from "i18n";
import { TTP_HUB_URL, TTP_ACCOUNTING_URL } from "Config";
import { fetchMail } from "Thunks";

import { getDateLabel, getUserNameForAvatar } from "Utils";
import classnames from "classnames";
import styles from "./Viewer.local.scss";

class Content extends PureComponent {
  render() {
    const { currentPage } = this.props;
    if (!currentPage) {
      return null;
    }
    const { id, resource } = currentPage;

    let url = `${TTP_HUB_URL}/pages/${id}`;

    switch (resource) {
      case "DASHBOARD":
        url = `${TTP_ACCOUNTING_URL}/folders`;
        break;
      default:
    }

    return (
      <div className={styles.pageModal}>
        <iframe
          src={url}
          sandbox="allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-forms"
        />
      </div>
    );
    // const { from, fromName, object, preview, date, sentAt, cid } = currentMail;

    // const helpDate = date ? date.date : sentAt ? sentAt.date : null;

    // return (
    //   <Fragment>
    //     <div className="cell rmodal__body">
    //       <div className={styles.metas}>
    //         <div className={styles.infos}>
    //           <h4>{fromName}</h4>
    //           <p>{object}</p>
    //           <span>
    //             De:<strong>{from}</strong>
    //           </span>
    //         </div>
    //         <div className={styles.date}>
    //           <span className={styles.dateTime}>{getDateLabel(helpDate)}</span>
    //           {this.renderAvatar()}
    //         </div>
    //       </div>
    //       <div className={styles.link}>
    //         <a
    //           href={`${TTP_API_URL}/mailing/web-version/${cid}`}
    //           alt={object}
    //           target="_blanck"
    //         >
    //           <i className="icon icon-share-alt" />
    //           <span>{_("Web version")}</span>
    //         </a>
    //       </div>
    //       <div className={styles.content}>
    //         <iframe srcdoc={preview} title={object} />
    //       </div>
    //     </div>
    //   </Fragment>
    // );
  }
}

const mapStateToProps = (state, ownProps) => ({
  currentPage: state.pageViewer.currentPage,
  user: state.auth.user
});
const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Content);



// WEBPACK FOOTER //
// ./src/components/Reveal/PageViewer/Content.js